
//Instalados
import React,{useRef,useState,useCallback} from "react";
import { Form } from '@unform/web';
import axsLogo from "../Images/AxsLogo.svg";
import getValidationErrors from "../../utils/getValidationErrors";
import { FormHandles } from "@unform/core";
import { useProgress } from "../../hooks/progress";
import {IDataLogin} from "../../@Types";
import success from '../Toast/Image/check.svg';
import error from '../Toast/Image/error.svg';
import Toast from '../Toast/Toast';
import * as Yup from "yup";
import api from "../../services/api/index";
import setaVoltar from "../Images/SetaVoltar.svg";

//Próprios
import "../Login/css/MasterLogin.css";
import "../Login/css/MasterLoginMobile.css";
import { Input } from '../Inputs/Input';

window.onload = function(){
  localStorage.removeItem("@ARP-adesao");
  localStorage.removeItem("@ARP-economia");
  localStorage.removeItem("@ARP-home");
  localStorage.removeItem("@ARP-beneficios");
  localStorage.removeItem("@ARP-card");
  localStorage.removeItem("@ARP-holderdata");
  localStorage.removeItem("@ARP-filldata");
  localStorage.removeItem("@ARP-consumo");
  localStorage.removeItem("@ARP-commercial");
  localStorage.removeItem("@ARP-modalCheck");
}

export default function RememberPassword() {
  const useFormRef = useRef<FormHandles>(null);
  const { setLoad } = useProgress();
  const [list, setList] = useState<any>([]);

  const showToast = useCallback((type: any) => {
    let toastProperties: { id: number; title: string; description: string; backgroundColor: string; icon: any; } | null = null;
    const id = Math.floor((Math.random() * 101) + 1);

  switch(type) {
      case 'success':
        toastProperties = {
          id,
          title: '',
          description:'Login efetuado',
          backgroundColor: '#f0ad4e',
          icon: success
        }
        break;
        case 'segundo':
          toastProperties = {
            id,
            title: '',
            description:'Email enviado',
            backgroundColor: '#f0ad4e',
            icon: success
          }
          break;  
      case 'warning':
        toastProperties = {
          id,
          title: '',
          description:'Erro ao efetuar login',
          backgroundColor: '#f0ad4e',
          icon: error
        }
        break;
        case 'primeiro':
          toastProperties = {
            id,
            title: '',
            description:'Enviando email...',
            backgroundColor: '#f0ad4e',
            icon: success
          }
          break;
        case 'modal':
            toastProperties = {
              id,
              title: '',
              description:'Cadastre sua senha...',
              backgroundColor: '#f0ad4e',
              icon: success
            }
            break;
      case 'inexistente':
          toastProperties = {
            id,
            title: '',
            description:  'Usuário inexistente',
            backgroundColor: '#f0ad4e',
            icon: error
          }
          break;
      case 'erro':
            toastProperties = {
              id,
              title: '',
              description:  'Erro',
              backgroundColor: '#f0ad4e',
              icon: error
            }
            break;

        default:
          setList([]);
    }
    setList([...list, toastProperties]);
  },[list])


const dataSend = useCallback(
  // Incompleto!
  (data) => {
    const dataLogin: IDataLogin = {
      email: data.email,
      senha: data.senha,
    };

    return dataLogin;
  },
  []
);
const handleSubmit = useCallback(
  async (data) => {
    try {
      // eslint-disable-next-line
      useFormRef.current?.setErrors({});

      const basicValidation = Yup.object().shape({
        // dados informe consumo
        email: Yup.string().required("Informe o E-mail"),
      });
      await basicValidation.validate(data, {
        abortEarly: false,
      });

      const sendData = dataSend(data);
      setLoad(true)
          
      await api.post('/csp/representante/recuperar/acesso/', sendData ).then(res => {
        if(res.status === 200){
          setLoad(false);
          setTimeout(function() {
            showToast('primeiro');
          }, 1000);
    
          setTimeout(function() {
            setLoad(false);
            showToast('segundo');
          }, 3000);

          setTimeout(function() {
              window.location.href = "/arp/login/"
          }, 4000);
      }
       }).catch((error) => {
         setLoad(false);
       }); 
       setLoad(false)
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        // eslint-disable-next-line
        useFormRef.current?.setErrors(errors);
      } else {
        //showToast("catchSalvarRegistro");
      }
    }
    setLoad(false);
  },
  [setLoad,dataSend,showToast]
);

const handleBack = (() => {
  window.location.href = "/arp/login/"
});

return (
  <>    

<Toast
    toastList={list}
    autoDelete={true} 
  />
    <div className="GridLogin">
          <div className="DivMotivation">
          <div onClick={handleBack}><img  className="imgSeta" src={setaVoltar} alt='' /></div>
            <div className="DivTextMotivation">
              <div className="Conic"><span className="Aspas"></span></div>
                Seja positivo, trabalhe duro e faça acontecer.
              </div>
          </div>
            <div className="DivInputs">
              <div className="DivTextInputs">Não se preocupe!</div>
              <div className="DivSecondTextInputs">
              Em até 2 minutos, enviaremos um link para a alteração de senha através do seu e-mail ou telefone cadastrados.
              </div>
              <br/>
              <div className="Inputs">
              <Form ref={useFormRef}
                onSubmit={handleSubmit}
              >
                <Input
                  type="text"
                  id="inputEmailEsqSenhaARP"
                  name="email"
                  placeholder="E-mail"
                  className="form-control"
                  style={{ width: '100%', backgroundColor: '#f5f5f5', border: 'none' }} />
                  <button type="submit" id="btnEsqSenhaARP" className="btnPurple">Enviar</button>
                  <br/>
                  <div className="DivTerceTextInputs" style={{cursor:'pointer'}}>
                    Não recebeu o link? <span className="DivTextPurple">Reenviar</span>
                  </div>
               </Form>

              </div>
              <img className="imgFinal" src={axsLogo} alt='' />
            </div>
    </div>
  </>
    );
  }
